import type { AnyAction } from 'redux'

// Where the current one-off order was started from. Only the empty-state dashboard sets a value;
// every other entry point records null.
export const ONE_OFF_ORDER_ORIGIN = {
  emptyStateDashboard: 'empty_state_dashboard',
} as const

export type OneOffOrderOrigin =
  | typeof ONE_OFF_ORDER_ORIGIN[keyof typeof ONE_OFF_ORDER_ORIGIN]
  | null

export const SET_ONE_OFF_ORDER_ORIGIN = 'oneOffOrderOrigin/set'

// Not stored in `temp`: that slice is reset by the confirmation wrapper and the delivery-details
// modal, which would clobber this mid-journey.
export const oneOffOrderOriginReducers = {
  oneOffOrderOrigin: (state: OneOffOrderOrigin = null, action: AnyAction): OneOffOrderOrigin => {
    switch (action.type) {
      case SET_ONE_OFF_ORDER_ORIGIN:
        return action.origin ?? null
      default:
        return state
    }
  },
}
